/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { clientUtil } from "@html-core";
import { RemoteUsbDevice } from "../../usb-remote";
import { SplitDevice } from "./split-device";

export class SplitDeviceFilter {
   public static check(exintf: Array<any>, remoteUsb: RemoteUsbDevice): SplitDevice | null {
      if (clientUtil.isChromeClient()) {
         if (exintf.length > 0) {
            return new SplitDevice(remoteUsb, exintf);
         }
      }
      return null;
   }
}
